import { BottomNavigation, Button, Grid, Stack } from '@mui/material';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Iconify from '../../../components/iconify';
import { useLocales } from '../../../locales';
import SvgColor from 'src/components/svg-color';
import { routePrefix } from 'src/utils/methods/StandardMethods';
import { useAuthContext } from '../../../auth/hooks';
import { PATH_DASHBOARD } from '../../../routes/paths';

type Props = {
  onOpenNav?: VoidFunction;
};

// const icon = (name: string) => (
//   <SvgColor src={`/assets/icons/navbar/${name}.svg`}  style={{  }} sx={{  fontSize: '25px' }} />
//   // OR
//   // <Iconify icon="fluent:mail-24-filled" />
//   // https://icon-sets.iconify.design/solar/
//   // https://www.streamlinehq.com/icons
// );

const BottomNavigationButtons = ({ onOpenNav }: Props) => {

  const location = useLocation();
  const { translate } = useLocales();
  const navigate = useNavigate();
  const { user } = useAuthContext();
  const [value, setValue] = useState(0);
  return (
    <>
      <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1, overflow: 'hidden' }} elevation={3}>
        {location.pathname.includes('list') ?
          <Stack direction='row'>
            <Grid container>
              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant='text' color='inherit' size='large' sx={{ borderRadius: '0px', width: '100%' }}><Iconify icon={'solar:sort-vertical-linear'} />{translate("Sort")}</Button>
              </Grid>
              <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button variant='text' color='inherit' size='large' sx={{ borderRadius: '0px', width: '100%' }}><Iconify icon={'material-symbols:filter-list'} />{translate("Filter")}</Button>
              </Grid>
            </Grid>
          </Stack>
          : (location.pathname.includes('home')) ?
            <BottomNavigation
              showLabels
              value={value}
              onChange={(event, newValue) => {
                if (newValue < 4)
                  setValue(newValue);
              }}
            >
              <BottomNavigationAction onClick={() => { navigate(PATH_DASHBOARD.home.home(routePrefix(user))) }} key='home' label={translate("Home")} icon={<Iconify icon="ant-design:home-twotone" style={{ fontSize: '25px' }} />} />
              <BottomNavigationAction onClick={() => { navigate(PATH_DASHBOARD.dashboard.dash(routePrefix(user))) }} key="dashboard" label={translate("Dashboard")} icon={<Iconify icon="ant-design:dashboard-twotone" style={{ fontSize: '25px' }} />} />
              <BottomNavigationAction onClick={() => { navigate(PATH_DASHBOARD.upload.upload(routePrefix(user))) }} key='upload' label={translate("Upload")} icon={<Iconify icon="ant-design:cloud-upload-outlined" style={{ fontSize: '25px' }} />} />
              {/* <BottomNavigationAction key='scan' label="Scan" icon={<Link to='/scan' style={{ color: 'inherit', marginBottom: '-3px' }}><Iconify icon="ri:qr-scan-2-line" style={{ fontSize: '25px' }} /></Link>} /> */}
              {/* <BottomNavigationAction key='product' label="Product" icon={<Link to={PATH_DASHBOARD.product.list} style={{ color: 'inherit' }}><Iconify icon="ic:twotone-inventory-2" style={{ fontSize: '25px' }} /></Link>} /> */}
              <BottomNavigationAction onClick={() => { navigate(PATH_DASHBOARD.themeSettings.settings(routePrefix(user))) }} key='theme' label={translate("Theme")} icon={<Iconify icon='material-symbols:settings-night-sight-outline' style={{ fontSize: '25px' }} />} />
              <BottomNavigationAction onClick={() => { navigate(PATH_DASHBOARD.book.list(routePrefix(user))) }} key='book' label={translate("Book")} icon={<Iconify icon="ant-design:book-twotone" style={{ fontSize: '25px' }} />} />
              <BottomNavigationAction key='More' label={translate("More")} icon={<Iconify icon="ci:more-grid-big" style={{ fontSize: '25px' }} />} onClick={onOpenNav} />
            </BottomNavigation > : <></>}
      </Paper >
    </>
  )
}

export default BottomNavigationButtons;
